module.exports = __webpack_public_path__ + "static/img/DeVries.26a627d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DeVries.jpg
// module id = 4rGx
// module chunks = 1